import { DateFormat } from '../../App/types';
import { getCurrentDate } from './getCurrentDate';

/**
 * Returns the current date and time in the given format.
 * @param {DateFormat} format - The server format to use for formatting.
 * @returns {string} The current date and time as a string, in the given format.
 */
export const getCurrentDateFormatted = (format: DateFormat): string => getCurrentDate().format(format);
